<div class="panel">
  <h2>Autres</h2>

  <div class="form-group">
    <label for="id">Identifiant</label>
    <span id="id" class="value">{{ entity.id }}</span>
  </div>

  <div class="form-group">
    <label for="createdAt">Date d'ajout</label>
    <span id="createdAt" class="value">{{ entity.createdAt | tzdate }}</span>
  </div>

  <div class="form-group">
    <label for="createdBy">Ajoutée par</label>
    <span id="createdBy" class="value">{{ entity.createdBy.fullname }}</span>
  </div>

  <div class="form-group">
    <label for="updatedAt">Date de modification</label>
    <span id="updatedAt" class="value">{{ entity.updatedAt | tzdate }}</span>
  </div>

  <div class="form-group">
    <label for="updatedBy">Modifiée par</label>
    <span id="updatedBy" class="value">{{ entity.updatedBy.fullname }}</span>
  </div>
</div>